import { ColorPicker } from "@mimber/ui-web"
import { FormItem } from "react-hook-form-antd"
import {
  useFormContext,
  FieldValues,
  FieldPath,
  Controller,
} from "react-hook-form"
import type { ColorPickerFieldProps } from "./ColorPickerField.types"

/**
 * ColorPickerField component that integrates React Hook Form with Ant Design ColorPicker
 * Uses react-hook-form-antd's FormItem for seamless integration
 * Note: Uses Controller for custom onChange logic to convert color to hex string
 */
export function ColorPickerField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  disabled,
  tooltip,
  showText = true,
}: ColorPickerFieldProps<TFieldValues, TName>) {
  const { control: contextControl } = useFormContext<TFieldValues>()
  const formControl = control || contextControl

  return (
    <FormItem
      control={formControl}
      name={name}
      label={label}
      required={required}
      help={help}
      tooltip={tooltip}
    >
      <Controller
        name={name}
        control={formControl}
        render={({ field }) => (
          <ColorPicker
            value={field.value}
            onChange={(color) => field.onChange(color.toHexString())}
            showText={showText}
            disabled={disabled}
            style={{ width: "100%" }}
          />
        )}
      />
    </FormItem>
  )
}
